import { API_URL } from '@/app/core/common/config';
import {
    createApiClient as sharedCreateApiClient,
    setApiClient,
} from '@fifa-bsm/bo-frontend-shared/core';

export const createApiClient = () => sharedCreateApiClient({ baseURL: `${API_URL}/` });

export const apiClient = createApiClient();

setApiClient(apiClient);

export const apiUrl = (url) => `${API_URL}/${url}`;
